import { render, staticRenderFns } from "./PanelLink.vue?vue&type=template&id=1bd98197&scoped=true"
import script from "./PanelLink.vue?vue&type=script&lang=ts"
export * from "./PanelLink.vue?vue&type=script&lang=ts"
import style0 from "./PanelLink.vue?vue&type=style&index=0&id=1bd98197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd98197",
  null
  
)

export default component.exports